import { kmsClient } from 'api';
import { useMutation } from '@apollo/react-hooks';
import { AUDIENCE_ENHANCEMENT_MUTATION } from './audienceEnhancement.mutation';
import { AudienceEnhancement, AudienceEnhancementVariables } from './__generated__/AudienceEnhancement';

export const useAudienceEnhancement = () => {
  return useMutation<AudienceEnhancement, AudienceEnhancementVariables>(AUDIENCE_ENHANCEMENT_MUTATION, {
    client: kmsClient
  });
};
